import { useQuery } from '@tanstack/react-query';
import { QueryKeys } from 'utils/queryKeys.ts';
import { trackError } from '@proposify/frontend-observability';
import { ApiDocumentSettingsRepository } from '../../services/document-settings/ApiDocumentSettingsRepository.ts';

export const useListCurrencyQuery = () => {
  const { data, isLoading, error } = useQuery({
    queryFn: ApiDocumentSettingsRepository.availableCurrencies,
    queryKey: [QueryKeys.documentSettingsCurrencies],
    throwOnError: (error: Error) => {
      trackError(error);
      return false;
    },
  });

  return {
    data: data ?? [],
    isLoading,
    error,
  };
};
